import { createFileRoute } from '@tanstack/react-router';

import { PublisherEditorPage } from '../features/supply/publishers/components/PublisherEditorPage/PublisherEditorPage';

export const Route = createFileRoute('/supply/publishers_/create')({
  component: PublisherEditorPage,
});
